import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';
import APP_CONFIG from '../config/appConfig';

// Public Pages
import Home from '../pages/Home';
import Poetry from '../pages/Poetry';
import Blogs from '../pages/Blogs';
import Gallery from '../pages/Gallery';
// SHOP DISABLED - Client request
// import Shop from '../pages/Shop';
// import Cart from '../pages/Cart';
import Contact from '../pages/Contact';

// Admin Pages (only imported when in admin mode)
import AdminLogin from '../pages/Admin/AdminLogin';
import Dashboard from '../pages/Admin/Dashboard';
import ManageBlogs from '../pages/Admin/ManageBlogs';
import ManagePoetry from '../pages/Admin/ManagePoetry';
import ManageGallery from '../pages/Admin/ManageGallery';
import ManageProducts from '../pages/Admin/ManageProducts';

const PublicLayout = () => {
  const isAdminMode = APP_CONFIG.isAdminMode();
  
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <main className="min-h-screen bg-black">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/poetry" element={<Poetry />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/gallery" element={<Gallery />} />
          {/* SHOP DISABLED - Client request */}
          {/* <Route path="/shop" element={<Shop />} /> */}
          {/* <Route path="/cart" element={<Cart />} /> */}
          <Route path="/contact" element={<Contact />} />
          
          {/* Admin Routes (only available in admin mode) */}
          {isAdminMode && (
            <>
              <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<Dashboard />} />
              <Route path="/admin/blogs" element={<ManageBlogs />} />
              <Route path="/admin/poetry" element={<ManagePoetry />} />
              <Route path="/admin/gallery" element={<ManageGallery />} />
              <Route path="/admin/products" element={<ManageProducts />} />
            </>
          )}
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default PublicLayout;
